{
  "it": {
    "filteredList": {
      "actions": {
        "showFilter": "Mostra filtri",
        "hideFilter": "Nascondi filtri"
      }
    }
  }
}
